import type { IconProps } from '../types/IconProps.ts';
export const Notification: IconProps = {
    name: 'Notification',
    children: [
        `<path d="M5 9a7 7 0 0 1 14 0v4.06a4 4 0 0 0 .42 1.78l1.16 2.32a4 4 0 0 1 .42 1.78V19H3v-.06a4 4 0 0 1 .42-1.78l1.16-2.32A4 4 0 0 0 5 13.06zM10 22h4" />`,
    ]
};